import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';
import HeaderButtons from '../header-buttons';
import PageMenuButton from '../../containers/page-menu-button';
import HeaderTitle from '../header-title';
import withButtonColor from '../../hoc/with-button-color';
import withFontClassName from '../../hoc/with-font-class-name';
import styles from './header.scss';

export class Header extends Component {
  render() {
    const { left, right, menu, contentFontClassName, buttonColor } = this.props;
    const containerClassName = classNames(styles.headerContainer, 'button-primary-text-color', contentFontClassName);
    const wrapperClassName = classNames(styles.header, 'default-button-background-color');

    return (
      <div className={containerClassName}>
        <div className={wrapperClassName} style={{ backgroundColor: buttonColor }}>
          {left}
          {right}
        </div>
        {menu || null}
      </div>
    );
  }
}

Header.propTypes = {
  contentFontClassName: PropTypes.string.isRequired,
  buttonColor: PropTypes.string.isRequired,
  left: PropTypes.node,
  right: PropTypes.node,
  menu: PropTypes.node,
};

Header.defaultProps = {
  right: <HeaderButtons/>,
  left: (
    <div className={styles.left}>
      <span className={styles.menuButton}>
        <PageMenuButton/>
      </span>
      <HeaderTitle/>
    </div>
  ),
};

export default withButtonColor(withFontClassName(Header));



// WEBPACK FOOTER //
// ./app/components/header/header.js